/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Ravens View variant availability
 *
 * - Sold-out sizes stay visible, but are crossed out and cannot be selected.
 * - A color is hidden when none of its variants can be purchased.
 * - When changing color makes the selected size unavailable, the first
 *   available size for that color is selected automatically.
 *
 * Shopify's `available` value is used deliberately. Variants configured with
 * "Continue selling when out of stock" therefore remain selectable.
 */
(function () {
  'use strict';

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function dispatchChange(input) {
    var event = document.createEvent('Event');
    event.initEvent('change', true, false);
    input.dispatchEvent(event);
  }

  function getOptionItem(input) {
    return input.closest ? input.closest('.HorizontalList__Item') : input.parentNode;
  }

  function setOptionState(input, unavailable, hidden) {
    var item = getOptionItem(input);

    input.disabled = unavailable;

    if (unavailable) {
      input.setAttribute('aria-disabled', 'true');
    } else {
      input.removeAttribute('aria-disabled');
    }

    if (item) {
      item.classList.toggle('RVVariantOption--unavailable', unavailable && !hidden);
      item.classList.toggle('RVVariantOption--hidden', hidden);
    }
  }

  function initProduct(section) {
    if (!section || section.getAttribute('data-rv-variant-availability-initialized') === 'true') {
      return;
    }

    var productJson = section.querySelector('[data-product-json]');
    var form = section.querySelector('form.ProductForm');

    if (!productJson || !form) {
      return;
    }

    var data;

    try {
      data = JSON.parse(productJson.textContent || productJson.innerHTML);
    } catch (error) {
      return;
    }

    var variants = data && data.product && data.product.variants ? data.product.variants : [];
    var optionContainers = toArray(form.querySelectorAll('.ProductForm__Option[data-rv-option-position]'));

    if (!variants.length || !optionContainers.length) {
      return;
    }

    section.setAttribute('data-rv-variant-availability-initialized', 'true');

    function getSelections() {
      var selections = {};

      optionContainers.forEach(function (container) {
        var position = parseInt(container.getAttribute('data-rv-option-position'), 10);
        var selectedInput = container.querySelector('input[type="radio"]:checked');

        if (position && selectedInput) {
          selections[position] = selectedInput.value;
        }
      });

      return selections;
    }

    function isVariantAvailableForValue(variant, position, value, selections, matchOtherSelections) {
      if (!variant.available || !variant.options || variant.options[position - 1] !== value) {
        return false;
      }

      if (!matchOtherSelections) {
        return true;
      }

      return Object.keys(selections).every(function (selectedPosition) {
        var numericPosition = parseInt(selectedPosition, 10);
        return numericPosition === position || variant.options[numericPosition - 1] === selections[selectedPosition];
      });
    }

    function updateAvailability() {
      var selections = getSelections();

      optionContainers.forEach(function (container) {
        var position = parseInt(container.getAttribute('data-rv-option-position'), 10);
        var optionType = container.getAttribute('data-rv-option-type');
        var inputs = toArray(container.querySelectorAll('input[type="radio"]'));

        if (optionType === 'color') {
          inputs.forEach(function (input) {
            var colorAvailable = variants.some(function (variant) {
              return isVariantAvailableForValue(variant, position, input.value, selections, false);
            });

            setOptionState(input, !colorAvailable, !colorAvailable);
          });
        }
      });

      /* Re-read selections in case a non-current color was disabled above. */
      selections = getSelections();

      optionContainers.forEach(function (container) {
        var position = parseInt(container.getAttribute('data-rv-option-position'), 10);
        var optionType = container.getAttribute('data-rv-option-type');
        var inputs = toArray(container.querySelectorAll('input[type="radio"]'));
        var replacementSize = null;

        if (optionType !== 'size') {
          return;
        }

        inputs.forEach(function (input) {
          var sizeAvailable = variants.some(function (variant) {
            return isVariantAvailableForValue(variant, position, input.value, selections, true);
          });

          setOptionState(input, !sizeAvailable, false);

          if (!replacementSize && sizeAvailable) {
            replacementSize = input;
          }
        });

        var selectedSize = container.querySelector('input[type="radio"]:checked');

        if (selectedSize && selectedSize.disabled && replacementSize) {
          replacementSize.checked = true;
          window.setTimeout(function () {
            dispatchChange(replacementSize);
          }, 0);
        }
      });
    }

    var updateQueued = false;

    form.addEventListener('change', function (event) {
      if (!event.target.matches('.ProductForm__Option input[type="radio"]')) {
        return;
      }

      if (updateQueued) {
        return;
      }

      updateQueued = true;

      window.setTimeout(function () {
        updateQueued = false;
        updateAvailability();
      }, 0);
    });

    updateAvailability();
  }

  function initAll(root) {
    var sections = [];

    if (root.matches && root.matches('[data-section-type="product"], [data-section-type="featured-product"]')) {
      sections.push(root);
    }

    sections = sections.concat(toArray(root.querySelectorAll('[data-section-type="product"], [data-section-type="featured-product"]')));
    sections.forEach(initProduct);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  /* Update collection-card sizes when the customer selects another color. */
  document.addEventListener('change', function (event) {
    var target = event.target;

    if (!target.matches('.ProductItem .ColorSwatch__Radio')) {
      return;
    }

    var productItem = target.closest('.ProductItem');

    if (!productItem) {
      return;
    }

    toArray(productItem.querySelectorAll('.ProductItem__SizeList')).forEach(function (sizeList) {
      if (sizeList.getAttribute('data-rv-color-value') === target.value) {
        sizeList.removeAttribute('hidden');
      } else {
        sizeList.setAttribute('hidden', 'hidden');
      }
    });
  });
}());
